<template>
  <div class="creat-reports-vue-container"
       element-loading-text="Создание отчета..."
       v-loading="loading">
    <div>
      <el-form v-loading="loader" class="reports-create" label-position="top">
        <div class="reports-edit-header" v-if="$route.params.id">
          <div @click="deleteReport" :class="['i-container', {'disable-report': form.approve || form.isWorkOrder}]"
               v-if="showDelete && !this.form.timesheetId">
            <i class="el-icon-delete"></i>
            <span>Удалить отчет</span>
          </div>
          <div
            @click="copyReport"
            v-if="!from && isReportEnabledByPlan($store) && !this.form.timesheetId "
            :class="['i-container', {'disable-report': form.isWorkOrder}]"
          >
            <i class="el-icon-document-copy"></i>
            <span>Копировать отчет</span>
          </div>
          <div v-if="isApprove" class="i-container" @click="approve">
            <i class="el-icon-circle-check" style="font-size: 28px"></i>
            <span>Утвердить отчет</span>
          </div>
        </div>
        <div class="date-create">
          <div style="display: flex; align-items: center" :class="{'disable-report': form.approve || form.isWorkOrder}">
            <el-date-picker
              :disabled="!!from || this.form.timesheetId"
              :editable="false"
              format="yyyy-MM-dd"
              v-model="form.datetime"
              :picker-options="pickerOptions"
              type="date"
              placeholder="Укажите дату"
            >
            </el-date-picker>
            <i class="el-icon-success" v-if="form.approve"></i>
          </div>
          <h4>
            <small>Номер отчета</small>
            <span v-if="!form.isWorkOrder">#{{ form.index }}</span>
            <span v-else @click="navigateToWorkOrder" style="text-decoration: underline; cursor: pointer">#{{
                form.index
              }}</span>

          </h4>
        </div>

        <div>

          <div v-if="$route.params.type !== 'COVID' && $route.params.type !== 'WILD_PIPE'">
            <div class="add-btn" :class="{'disable-report': form.approve || form.isWorkOrder}">
              <AddObjects
                :disabled="this.form.timesheetId"
                v-if="!from"
                :isSelect="!!form.object"
                @add-objects="addObject"
              />
              <div class="report-li-title" v-if="form.object">
                Выбранный объект: <strong>{{ ` ` + (form.object.name || 'Корневой каталог') }}</strong>
              </div>
            </div>
            <ListJobs
              :dirs="dirs"
              :blockAddMore="this.form.timesheetId"
              :available_reports="available_reports"
              :options_works="options_works"
              :propsForm="form"
              @update="(f) => form = f"
              v-if="$route.params.type === 'TECH' || $route.params.type === 'PROF' || $route.params.type === 'MATERIALS'"
            />

            <div class="report-add-job" v-else>
              <div class="report-ul">
                <div
                  v-for="(job, index) in form.jobs" :key="index + '' + (job && job.id) || 0" class="report-li"
                >
                  <div v-if="!job.is_daily" style="width: 100%">
                    <div :class="{'disable-report': form.approve || form.isWorkOrder}"
                         style="display: flex; justify-content: space-between; align-items: center">
                    <span style="margin-bottom: 10px">
                      {{
                        job.job && job.job.name
                      }}, <strong>{{ job.job && job.job.unit && job.job.unit.label || job.job.unit }}</strong>
                    </span>
                      <i
                        :class="{'disable-report': form.approve || form.isWorkOrder}"
                        v-if="$route.params.type === 'JOB'" style="font-size: 18px; margin-left: 16px"
                        @click="copyJob(index)" class="el-icon-document-copy"></i>
                      <div v-if="$route.params.type !== 'JOB'">
                        <i @click="deleteJob(index)" class="el-icon-close"></i>
                      </div>
                    </div>

                    <div
                      style="display: flex; justify-content: space-between; align-items: center; width: 100%; margin-top: 15px">
                      <div class="report-value" v-if="!job.is_daily" style="max-width: calc(100% - 70px)"
                           :class="{'disable-report': form.approve || form.isWorkOrder}">
                        <el-input type="number" v-model="job.value || job.job.value"/>

                      </div>
                      <div v-if="$route.params.type === 'JOB'">
                        <i class="fa fa-edit" @click="openEdit(job, index)" style="padding-top: 2px"></i>

                      </div>
                    </div>
                    <el-input
                      :class="{'disable-report': form.approve || form.isWorkOrder}"
                      style="margin-top: 10px;"
                      placeholder="Комментарий"
                      type="textarea"
                      v-model="job.comment"
                    />
                  </div>
                  <div v-else>
                    <div class="report-value" style="justify-content: space-between">
                      <strong>{{ job.job && job.job.name }}, {{ job.job && job.job.unit }}</strong>

                      <div v-if="$route.params.type !== 'JOB'">
                        <i @click="deleteJob(index)" class="el-icon-close"></i>
                      </div>

                      <i
                        :class="{'disable-report': form.approve || form.isWorkOrder}"
                        style="font-size: 18px" @click="copyJob(index)" class="el-icon-document-copy"></i>

                    </div>
                    <div style="margin-top: 10px">
                      <div style="display: flex; justify-content: space-between; flex: 1; width: 100%">
                        <el-row :class="{'disable-report': form.approve || form.isWorkOrder}">
                          <el-col :span="$route.params.type === 'JOB' ? 12 : 12">
                            <el-input type="number" :value="job.daily_plan"/>
                          </el-col>
                          <el-col :span="$route.params.type === 'JOB' ? 12: 12">
                            <el-input type="number" v-model="job.value"/>
                          </el-col>
                        </el-row>
                        <div v-if="$route.params.type === 'JOB'"
                             style="padding-top: 6px; margin-left: 8px; padding-left: 12px; display: flex; justify-content: flex-end">
                          <i class="fa fa-edit" @click="openEdit(job, index)"></i>
                        </div>
                      </div>
                      <el-input
                        :class="{'disable-report': form.approve || form.isWorkOrder}"
                        style="margin-top: 10px;"
                        placeholder="Комментарий"
                        type="textarea"
                        v-model="job.comment"
                      />
                    </div>

                  </div>
                </div>
                <AddJobs
                  :dirs="dirs"
                  :approve="form.approve || form.isWorkOrder"
                  :class="{'disable-report': form.approve || form.isWorkOrder}"
                  ref="addJob"
                  :options_works="options_works"
                  :report="form"
                  v-if="!updateChildFlag"
                  :childForm="childForm"
                  @add-prof="(uid) => createReport('PROF', uid)"
                  @add-tech="(uid) => createReport('TECH', uid)"

                  @remove="deleteJob"
                  @close="closeJob"
                  :type="$route.params.type === 'MAIN' ? 'JOB' : undefined"
                  @add-job="addJob" :obj="form.object"/>
              </div>
            </div>
          </div>
          <!--          <div style="margin-top: 20px">-->
          <!--            <filter-select-->
          <!--              multiple-->
          <!--              v-model="form.notifications"-->
          <!--              label="Уведомить"-->
          <!--              :options="allUsers"-->
          <!--            />-->
          <!--          </div>-->
          <div>
            <div v-if="role === 'admin'">
              <filter-select
                :class="{'disable-report': form.approve || form.isWorkOrder}"
                :disabled="!!from || this.form.timesheetId"
                v-if="$route.params.type === 'JOB' || $route.params.type === 'TECH' || $route.params.type === 'PROF'"
                v-model="form.user"
                label="Исполнитель"
                :options="usersOptions"
              />
            </div>
            <div :class="{'disable-report': form.approve || form.isWorkOrder}">
              <filter-select
                :disabled="!!from || this.form.timesheetId"
                v-model="form.turn"
                label="Смена"
                :options="shifts"
              />
            </div>


            <el-form-item :class="{'disable-report': form.approve || form.isWorkOrder}" :label="'Место работы'"
                          v-if="$route.params.type === 'MAIN'">
              <el-input v-model="form.place"/>
            </el-form-item>

            <filter-select
              :class="{'disable-report': form.approve || form.isWorkOrder}"
              v-if="$route.params.type === 'MATERIALS' || $route.params.type === 'MAIN'"
              v-model="form.leader"
              label="Исполнитель"
              :options="joint_options.executor"
            />

            <div v-if="$route.params.type === 'WILD_PIPE'"
                 :class="{'disable-report': form.approve || form.isWorkOrder}">
              <filter-select
                :value="form.line"
                @input="pickLine"
                label="Линия"
                :options="joint_options.lines"
              />

              <div class="line-data" v-for="(joint, index) in form.joints" :key="index" v-if="updated">
                <div class="pipe-close">
                  <i class="el-icon-close" @click="deleteJoint(index)" v-if="form.joints.length > 1"/>
                  <add-joint :line="current_line" @update="update" :joint="index"/>
                </div>


                <filter-select
                  multiple
                  @input="checkJoint"
                  v-model="joint.id_joint"
                  label="Номера стыков"
                  :options="joint_options.joints"
                />

                <filter-select
                  multiple
                  v-model="joint.welder"
                  single
                  label="Сварщики"
                  :options="joint_options.welders"
                />

                <filter-select
                  multiple
                  v-model="joint.materials"
                  single
                  label="Сварочные материалы"
                  :options="joint_options.materials"
                />

                <filter-select
                  v-model="joint.leader"
                  label="Бригадир"
                  :options="joint_options.team"
                />

                <el-form-item label="Оси и отметка">
                  <el-input v-model="joint.axe_elevation"/>
                </el-form-item>
              </div>
              <div class="add-block">
                <el-button @click="addJoint">Добавить</el-button>
              </div>
            </div>

            <div class="create-comment">
              <div style="display: flex; flex-direction: column" v-if="$route.params.type === 'JOB'">
                <div v-if="available_reports && available_reports.PROF">
                  <div class="dop-container" style="margin-bottom: 10px">
                    <strong>{{ form.reportPROF && $store.state.project.daily_plan ? 'Рабочие' : 'Численность' }} <span
                      v-if="$store.state.project.daily_plan">(план|факт)</span></strong>
                    <div class="report-child-btn">
                      <router-link :to="`/dashboard/reports/create/${form.reportPROF}/PROF`"
                                   style="margin-right: 10px; color: black" v-if="form.PROF.index">#{{
                          form.PROF.index
                        }}
                      </router-link>
                      <el-button @click="createReport('PROF')">
                        Отчет
                      </el-button>
                    </div>
                  </div>
                  <div v-if="form.reportPROF && !updateChildFlag">
                    <div v-if="$store.state.project.daily_plan">
                      <el-row>
                        <el-col :span="12" v-if="$store.state.project.daily_plan">
                          <el-input :class="{'disable-report':  form.approve || form.isWorkOrder}" type="number"
                                    placeholder="Рабочие план"
                                    :value="form.PROF.workers_plan"></el-input>
                        </el-col>
                        <el-col :span="12">
                          <el-input :class="{'disable-report':  form.approve || form.isWorkOrder}" type="number"
                                    placeholder="Рабочие факт"
                                    :value="form.PROF.workers"></el-input>
                        </el-col>
                      </el-row>
                      <div style="display: flex; justify-content: flex-start; margin-top: 12px">
                        <strong>ИТР <span v-if="$store.state.project.daily_plan">(план|факт)</span></strong>
                      </div>
                      <el-row style="margin-top: 10px">
                        <el-col :span="12" v-if="$store.state.project.daily_plan">
                          <el-input :class="{'disable-report':  form.approve || form.isWorkOrder}" type="number"
                                    placeholder="ИТР план"
                                    :value="form.PROF.itr_plan"></el-input>
                        </el-col>
                        <el-col :span="12">
                          <el-input :class="{'disable-report':  form.approve || form.isWorkOrder}" type="number"
                                    placeholder="ИТР факт"
                                    :value="form.PROF.itr"></el-input>
                        </el-col>
                      </el-row>
                    </div>
                    <div v-else>
                      <el-row>
                        <el-col :span="12">
                          <el-input :class="{'disable-report':  form.approve || form.isWorkOrder}" type="number"
                                    placeholder="Рабочие факт"
                                    :value="form.PROF.workers"></el-input>
                        </el-col>
                        <el-col :span="12">
                          <el-input :class="{'disable-report':  form.approve || form.isWorkOrder}" type="number"
                                    placeholder="ИТР факт"
                                    :value="form.PROF.itr"></el-input>
                        </el-col>
                      </el-row>
                    </div>
                  </div>
                </div>
                <div v-if="available_reports && available_reports.TECH">
                  <div class="dop-container" style="margin-top: 30px; margin-bottom: 10px">
                    <strong>Техника <span v-if="$store.state.project.daily_plan">(план|факт)</span></strong>
                    <div class="report-child-btn">
                      <router-link :to="`/dashboard/reports/create/${form.reportTECH}/TECH`"
                                   style="margin-right: 10px; color: black" v-if="form.TECH.index">#{{
                          form.TECH.index
                        }}
                      </router-link>
                      <el-button @click="createReport('TECH')">
                        Отчет
                      </el-button>
                    </div>
                  </div>
                  <el-row v-if="form.reportTECH">
                    <el-col :span="12" v-if="$store.state.project.daily_plan">
                      <el-input :class="{'disable-report':  form.approve || form.isWorkOrder}" type="number"
                                placeholder="Техника план"
                                :value="form.TECH.workers_plan"></el-input>
                    </el-col>
                    <el-col :span="12">
                      <el-input :class="{'disable-report':  form.approve || form.isWorkOrder}" type="number"
                                placeholder="Техника факт"
                                :value="form.TECH.workers"></el-input>
                    </el-col>
                  </el-row>
                </div>
              </div>

              <div
                v-if="($store.state.project.daily_plan && !from &&  ($route.params.type === 'TECH' || $route.params.type === 'PROF'))">
                <el-form-item label="Рабочие (план|факт)" v-if="$route.params.type !== 'TECH'">
                  <div v-if="$route.params.type !== 'TECH'">
                    <el-row>
                      <el-col :span="12">
                        <el-input :class="{'disable-report':  form.approve || form.isWorkOrder}" type="number"
                                  placeholder="Рабочие план"
                                  :value="planFact.plan"></el-input>
                      </el-col>
                      <el-col :span="12">
                        <el-input :class="{'disable-report':  form.approve || form.isWorkOrder}" type="number"
                                  placeholder="Рабочие факт"
                                  :value="planFact.fact"></el-input>
                      </el-col>
                    </el-row>
                  </div>
                </el-form-item>
                <el-form-item label="ИТР (план|факт)" v-if="$route.params.type !== 'TECH'">
                  <div v-if="$route.params.type !== 'TECH'">
                    <el-row style="margin-top: 10px">
                      <el-col :span="12">
                        <el-input :class="{'disable-report':  form.approve || form.isWorkOrder}" type="number"
                                  placeholder="ИТР план"
                                  :value="planFact.itr_plan"></el-input>
                      </el-col>
                      <el-col :span="12">
                        <el-input :class="{'disable-report':  form.approve || form.isWorkOrder}" type="number"
                                  placeholder="ИТР факт"
                                  :value="planFact.itr"></el-input>
                      </el-col>
                    </el-row>
                  </div>
                </el-form-item>
                <el-form-item v-else label="Техника (план|факт)">
                  <el-row>
                    <el-col :span="12">
                      <el-input :class="{'disable-report':  form.approve || form.isWorkOrder}" type="number"
                                :value="planFact.plan"
                                placeholder="Техника план"></el-input>
                    </el-col>
                    <el-col :span="12">
                      <el-input :class="{'disable-report':  form.approve || form.isWorkOrder}" type="number"
                                placeholder="Техника факт"
                                :value="planFact.fact"></el-input>
                    </el-col>
                  </el-row>
                </el-form-item>
              </div>

              <a @click="toParent" class="job-link" v-if="from">Отчет по работам #{{
                  parent.index || form.timesheetNumber
                }}</a>
              <a @click="toParent" class="job-link" v-if="form.timesheetId">Табель #{{ form.timesheetNumber }}</a>

              <el-form-item :class="{'disable-report':  form.approve || form.isWorkOrder}" label="Погода"
                            v-if="$route.params.type === 'JOB' && $store.state.project.weather">
                <el-input v-model="form.weather"></el-input>
              </el-form-item>

              <el-form-item label="Комментарии" :class="{'disable-report':  form.approve || form.isWorkOrder}">
                <div class="el-textarea">
                  <!--                  <vue-tribute :options="{...tributeOptions}">-->
                  <textarea class="el-textarea__inner" type="textarea"
                            v-model="form.comment"></textarea>
                  <!--                  </vue-tribute>-->
                </div>
              </el-form-item>
            </div>

            <div class="report-file">
              <UploadFile

                :disabled="this.form.timesheetId || form.approve || form.isWorkOrder"
                :fileListProps="fileList"
                @add-file="addFile"
              />
              <div :key="index" v-for="(file, index) in form.files" class="links-list">
                <a target="_blank" :href="file">Прикрепленный файл #{{ index + 1 }}</a>
                <i class="el-icon-delete" :class="{'disable-report':  form.approve || form.isWorkOrder}"
                   @click="deleteImg(index)"></i>
              </div>
            </div>
          </div>
        </div>

        <el-dialog :visible.sync="openAddJob" :custom-class="`create-new-jobs ${this.isHiden ? 'hidden-j' : ''}`"
                   @close="closeJobsList(openType)">
          <div style="display: flex; justify-content: flex-start; margin-top: 12px"
               :class="{'disable-report':  form.approve || form.isWorkOrder}"
               v-if="openType === 'PROF' && !openUidData">
            <el-popconfirm
              v-if="$store.state.project.work_dir && !$store.state.project.work_type_ignore"
              @confirm="autoComplete"
              @cancel="autoComplete('dir')"
              confirm-button-text='Видам работ'
              cancel-button-text='Разделам работ'
              title="Заполнить по “Видам работ” или “Разделам работ”?"
            >
              <el-button
                size="mini" slot="reference" style="margin-top: -26px">Автозаполнение
              </el-button>
            </el-popconfirm>
            <el-button
              size="mini" v-else-if="$store.state.project.work_dir || !$store.state.project.work_type_ignore"
              @click="autoComplete($store.state.project.work_dir ? 'dir': undefined)" style="margin-top: -26px">
              Автозаполнение
            </el-button>
          </div>
          <ListJobs
            :class="{'disable-report':  form.approve || form.isWorkOrder}"
            isModal
            ref="listJob"
            :dirs="dirs"
            v-if="!updateChildFlag"
            :uidData="openUidData"
            :blockAddMore="!!openUidData"
            :available_reports="available_reports"
            :originalForm="form"
            @close="(t) => saveJobsChild(t)"
            @closeWithoutSave="(t) => closeJobsList(t)"
            @update="updateChild"
            :type="openType"
            :props-form="childForm[openType]"
            :options_works="options_works"
          />
        </el-dialog>

        <el-dialog :visible.sync="dialogObject">
          <img style="width: 100%;" :src="previewSrc">
        </el-dialog>

        <el-dialog :visible.sync="dialogObject">
          <img style="width: 100%;" :src="previewSrc">
        </el-dialog>

        <div v-if="createOpen" class="create-modal">
          <div class="create-modal__body">
          </div>
        </div>
        <div class="create-footer">
          <el-button @click="back()">Назад</el-button>
          <el-button :disabled="this.form.timesheetId" type="primary" @click="saveReport()"
                     v-if="isReportEnabledByPlan($store) && !form.approve && !form.isWorkOrder">Сохранить
          </el-button>
        </div>
      </el-form>
    </div>
    <el-dialog
      title="Копировать отчет"
      :visible.sync="copyData.dialogVisible"
      width="300px"
      v-loading="copyData.loading"
    >
      <div style="display: flex; flex: 1; margin-left: 20px; margin-bottom: 4px">
        <strong>Дата нового отчета</strong>
      </div>
      <el-date-picker
        :picker-options="pickerOptions"
        v-model="copyData.pickData"
        type="date"
        :editable="false"
        :clearable="false"
        placeholder="Выбрать дату">
      </el-date-picker>
      <span slot="footer" class="center" style="display: flex; justify-content: center">
        <el-button @click="copyData.dialogVisible = false">Отмена</el-button>
        <el-button type="primary" @click="doCopy">Копировать</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import AddObjects from './components/AddObjects';
import AddJobs from './components/AddJobs';
import UploadFile from '@/views/Dashboard/Reports/components/UploadFile';
import firebase from 'firebase';
import dayjs from 'dayjs';
import Multiselect from 'vue-multiselect';
import AddJoint from './components/AddJoint';
import FilterSelect from '../../../components/FilterSelect';
import _, {uniq, uniqBy} from 'lodash';
import {toFloat} from '../../../utils/numberUtils';
import {fetchIndex, fetchReport} from "../../../firestore/reports";
import {calcJobsPlan} from "./mixins/calcJobsPlan";
import {isReportEnabledByPlan} from "../../../utils/permission";
import ListJobs from "./components/ListJobs";
import {getUsersOptions} from "../../../firestore/users";
import {getRole, isApprove} from "../../../firestore/permission";
import {autoComplateChild} from "./mixins/autocomplateChild";
import {copyReports} from "./mixins/copyReports";
import {v4 as uuidv4} from 'uuid';
import VueTribute from 'vue-tribute'
import {getCurrentMonth} from "../../../utils/date";

const isBetween = require('dayjs/plugin/isBetween');
dayjs.extend(isBetween);

export default {
  name: 'Create',
  components: {ListJobs, FilterSelect, AddJoint, UploadFile, AddJobs, AddObjects, Multiselect, VueTribute},
  data() {
    return {
      isLock: false,
      isApprove: false,
      dirs: [],
      isHiden: false,
      ...this.emptyData(),
      initBlock: false,
      dialogVisible: false,
      tributeOptions: {
        trigger: '@',
        noMatchTemplate: () => '<li>Пользователь не найден</li>',
        values: (text, cb) => this.getNames(text, cb)
      },
      updateChildFlag: false
    }
  },
  mixins: [calcJobsPlan, autoComplateChild, copyReports],
  async mounted() {
    this.isApprove = await isApprove(this.$store.state.project.id)
    try {
      const available_reports = (this.$store.state.project && this.$store.state.project.available_reports) || {};
      if (this.available_reports) {
        this.available_reports = {
          ...this.available_reports,
          ...available_reports,
        };
      }
    } catch (e) {
      setTimeout(() => {
        const available_reports = (this.$store.state.project && this.$store.state.project.available_reports) || {};
        if (this.available_reports) {
          this.available_reports = {
            ...this.available_reports,
            ...available_reports,
          };
        }
      }, 2000)
    }

    this.init();


    const users = await getUsersOptions(this.$store.state.project.id, true)
    this.usersOptions = users.filter((u) => u._data.isCompany)
    this.allUsers = users.filter((u) => !u._data.isCompany)

    const dirs = await myFirestore
      .collection('projects')
      .doc(this.$store.state.project.id)
      .collection('dirs')
      .get()

    dirs.forEach((d) => {
      this.dirs.push({id: d.id, ...d.data()})
    })
  },
  watch: {
    '$route.params': {
      async handler() {
        await this.init();
      },
      deep: true,
    },
  },
  computed: {
    pickerOptions() {
      if (this.$store.state.project.plan && this.$store.state.project.plan.id) {
        let month = getCurrentMonth(this.$store.state.project.plan.name);
        if (String(month).length === 1) {
          month = '0' + month
        }

        const year = this.$store.state.project.plan.name.split('-')[1]
        const unixDateEnd = dayjs(year + '-' + month + '-' + '31' + ' 00:00:00').unix() * 1000

        const unixDateStart = dayjs(year + '-' + month + '-' + '01' + ' 00:00:00').unix() * 1000

        return {
          disabledDate(time) {
            return time.getTime() > unixDateEnd || time.getTime() < unixDateStart;
          },
        }
      } else {
        return {}
      }
    },
    planFact() {
      const result = {
        itr: 0,
        plan: 0,
        fact: 0,
        itr_plan: 0,
      }

      this.form.jobs.forEach((jobs) => {
        jobs.forEach((j) => {
          if (j.job.kind && j.job.kind.value === 'itr') {
            result.itr = result.itr + Number(j.value)
            result.itr_plan = result.itr_plan + Number(j.plan)
          } else {
            result.fact = result.fact + Number(j.value)
            result.plan = result.plan + Number(j.plan)
          }
        })
      })


      return {
        ...result,
        updateChildFlag: this.updateChildFlag
      }
    },
    showDelete() {
      if (this.$store.state.project.plan) {
        return this.$store.state.project.plan.enabled
      }

      return !this.$store.state.project.directiveOff
    }
  },
  methods: {
    async navigateToWorkOrder() {
      let query = await myFirestore
        .collection('projects')
        .doc(this.$store.state.project.id)
        .collection('workorders').where('index', '==', this.form.workOrderIndex).get()

      query.forEach((d) => {
        this.$router.push(`/dashboard/workorders-reports/create/${d.id}`)
      })
    },
    getNames(t, sb) {
      const users = this.allUsers;

      const result = []
      const user = this.form.user || {}
      const reporter = this.form.reporter || {}


      users.forEach(({label, value}) => {
        if (this.form.notifications.find((u) => u.value === value) || user.uid === value || reporter.uid === value) {
          result.push({
            value: label,
            key: label
          })
        }
      })

      sb([
        {key: 'Все', value: 'Все'},
        ...result
      ])
    },
    approve() {
      this.form.approve = !this.form.approve

      if (this.$route.params.id) {
        const ids = [this.$route.params.id]

        if (this.form.reportPROF) {
          ids.push(this.form.reportPROF)
        }

        if (this.form.reportTECH) {
          ids.push(this.form.reportTECH)
        }

        ids.forEach((id) => {
          myFirestore
            .collection('projects')
            .doc(this.$store.state.project.id)
            .collection('reports')
            .doc(id)
            .update(JSON.parse(JSON.stringify({
              approve: this.form.approve,
              approveUser: this.form.approve ? {name: this.user.name, uid: authFirestore.currentUser.uid} : null
            })))
        })
      }
    },
    async closeJob(flag) {
      this.updateChildFlag = true
      const newProfJobs = []
      const newTechJobs = []

      this.childForm.PROF.jobs.forEach((jobs, index) => {
        const jobsResult = []

        jobs.forEach((job) => {
          if (!job.linkedUid) {
            jobsResult.push(job)
          }

          if (this.form.jobs.find(({uid}) => uid === job.linkedUid)) {
            if ((job.linkedUid !== flag.uid || flag.isPopulation) && (job.value !== '' || job.time !== '')) {
              jobsResult.push(job)
            }

            if ((job.linkedUid !== flag.uid || flag.isTech) && (job.value !== '' || job.time !== '')) {
              jobsResult.push(job)
            }
          }
        })

        if (jobsResult.length) {
          newProfJobs.push(jobsResult)
        } else {
          this.childForm[`PROF`].work_type[index] = null
          this.childForm[`PROF`].work_type_dir[index] = null
        }
      })


      this.childForm.TECH.jobs.forEach((jobs, index) => {
        const jobsResult = []

        jobs.forEach((job) => {
          if (!job.linkedUid) {
            jobsResult.push(job)
          }

          if (this.form.jobs.find(({uid}) => uid === job.linkedUid)) {
            if ((job.linkedUid !== flag.uid || flag.isTech) && (job.value !== '' || job.time !== '')) {
              jobsResult.push(job)
            }
          }
        })

        if (jobsResult.length) {
          newTechJobs.push(jobsResult)
        } else {
          this.childForm[`TECH`].work_type[index] = null
          this.childForm[`TECH`].work_type_dir[index] = null
        }
      })

      this.childForm.PROF.jobs = newProfJobs;
      this.childForm.TECH.jobs = newTechJobs;

      this.childForm = {
        ...this.childForm,
        PROF: {
          ...this.childForm.PROF,
          jobs: newProfJobs.length ? newProfJobs : [[]]
        },
        TECH: {
          ...this.childForm.TECH,
          jobs: newTechJobs.length ? newTechJobs : [[]]
        }
      }

      this.childFormSave = {
        ...this.childFormSave,
        PROF: {
          ...this.childFormSave.PROF,
          jobs: newProfJobs.length ? newProfJobs : [[]]
        },
        TECH: {
          ...this.childFormSave.TECH,
          jobs: newTechJobs.length ? newTechJobs : [[]]
        }
      }

      this.form[`PROF`] = {
        ...await this.updateParent(null, this.childForm['PROF']),
        index: this.form[`PROF`].index || null
      }

      this.form[`TECH`] = {
        ...await this.updateParent(null, this.childForm['TECH']),
        index: this.form[`TECH`].index || null
      }

      setTimeout(() => {
        this.updateChildFlag = false
        this.form = {...this.form}
        this.$forceUpdate()
      }, 100)
    },
    updateChild(f) {
      this.childForm[this.openType] = f
    },
    closeJobsList(t) {
      if (this.childFormSave[t] && this.childFormSave[t].jobs) {
        this.childFormSave[t].jobs = this.childFormSave[t].jobs.map((job) => {
          return uniqBy(job, 'uid')
        })
      }

      this.childForm[t] = JSON.parse(JSON.stringify({...this.childFormSave[t]}))

      this.openAddJob = false
      this.openUidData = null
      this.isHiden = false

    },
    async saveJobsChild(openType) {
      this.openAddJob = false
      this.childFormSave[openType] = JSON.parse(JSON.stringify({...this.childForm[openType]}));
      this.form[`${openType}`] = {
        ...await this.updateParent(null, this.childForm[openType]),
        index: this.form[`${openType}`].index || null
      }
      this.form[`report${openType}`] = this.form[`report${openType}`] || true

      this.$refs.addJob.getProfValue()
      this.$refs.addJob.getTechValue()

      // this.form.jobs =     this.form.jobs.map((j) => {
      //   return uniqBy(j, 'uid')
      // })

      this.openUidData = null
      this.isHiden = false
    },
    isReportEnabledByPlan,
    emptyData() {
      let job = [];

      if (this.$route.params.type === 'TECH' || this.$route.params.type === 'PROF' || this.$route.params.type === 'MATERIALS') {
        job = [[]];
      }

      return {
        tributeOptions: {
          trigger: '@',
          noMatchTemplate: () => '<li>Пользователь не найден</li>',
          values: (text, cb) => this.getNames(text, cb)
        },
        isApprove: false,
        approveReport: false,
        updateChildFlag: false,
        role: 'worker',
        form_saved: {},
        usersOptions: [],
        allUsers: [],
        plan: null,
        openUidData: null,
        from: null,
        searchable: {
          line: false,
        },
        weather: null,
        createOpen: false,
        openAddJob: false,
        openType: '',
        childFormSave: {
          PROF: {
            jobs: [[]],
            jobs_internal: [],
            work_type: [],
            work_type_dir: [],
            turn: {
              value: 1,
              label: 1,
            },
            daily_plan: {
              workers: '',
              itr: '',
            },
          },
          TECH: {
            jobs: [[]],
            jobs_internal: [],
            work_type: [],
            work_type_dir: [],
            turn: {
              value: 1,
              label: 1,
            },
            daily_plan: {
              workers: '',
              itr: '',
            },
          }
        },
        totalMaterials: 0,
        updated: true,
        fileList: [],
        loader: false,
        initData: false,
        dialogObject: false,
        previewSrc: null,
        loading: false,
        turn_plan: 0,
        isCreatedUser: false,
        joint_options: {
          lines: [],
          joints: [],
          welders: [],
          materials: [],
          team: [],
          executor: [],
        },
        shifts: [{
          label: 1,
          value: 1,
        }, {
          label: 2,
          value: 2,
        }, {
          label: 3,
          value: 3,
        }],
        user: {},
        current_line: {},
        options_works: [],
        available_reports: {
          JOB: true,
          TECH: true,
          PROF: true,
          COVID: true,
          WILD_PIPE: false,
          MATERIALS: false,
          MAIN: false,
        },
        parent: {},
        childForm: {
          PROF: {
            jobs: [[]],
            jobs_internal: [],
            work_type: [],
            work_type_dir: [],
            turn: {
              value: 1,
              label: 1,
            },
            daily_plan: {
              workers: '',
              itr: '',
            },
          },
          TECH: {
            jobs: [[]],
            jobs_internal: [],
            work_type: [],
            work_type_dir: [],
            turn: {
              value: 1,
              label: 1,
            },
            daily_plan: {
              workers: '',
              itr: '',
            },
          }
        },
        form: {
          notifications: [],
          approve: false,
          reportTECH: null,
          reportPROF: null,
          TECH: {
            workers: '',
            workers_plan: ''
          },
          PROF: {
            workers: '',
            itr: '',
            workers_plan: '',
            itr_plan: ''
          },
          jobs_internal: [],
          work_type: [],
          work_type_dir: [],
          daily_plan: {
            workers: '',
            itr: '',
          },
          joints: [{
            id_joint: null,
            welder: null,
            materials: null,
            leader: null,
            axe_elevation: null,
          }],
          leader: null,
          place: null,
          line: null,
          datetime: dayjs().format(),
          dateunix: dayjs(dayjs().format('YYYY-MM-DD') + 'T00:00:00+00:00').utc().unix(),
          comment: '',
          object: '',
          group: [],
          jobs: this.$route.params.type === 'COVID' ? {
            main: 0,
            fall: 0,
          } : job,
          index: 1,
          files: [],
          turn: {
            value: 1,
            label: 1,
          },
        },
      };
    },

    toParent() {
      if (!this.form.timesheetId) {
        this.$router.push({
          path: `/dashboard/reports/create/${this.from}/JOB`,
          query: {
            from: null
          }
        })
      } else {
        this.$router.push({
          path: `/dashboard/reports/create/${this.form.timesheetId}/TABEL`,
          query: {
            from: null
          }
        })
      }
    },
    async createReport(type, uidData = null, flag = false) {
      this.childForm['PROF'] = JSON.parse(JSON.stringify(this.childForm['PROF']))
      this.childFormSave['PROF'] = JSON.parse(JSON.stringify(this.childFormSave['PROF']))

      this.openAddJob = true;
      this.openType = type
      this.openUidData = uidData
      this.isHiden = flag
      // this.autoComplete($store.state.project.work_dir ? 'dir': undefined)
    },
    async back() {
      await this.$router.push(`/dashboard/reports/${this.$route.params.type}`)
    },
    async saveReport() {
      if (this.$store.state.project.work_type_require && this.$route.params.type === 'JOB') {
        const job_flat = _.flatten(this.childForm.PROF.jobs).length

        for (let job of _.flatten(this.childForm.PROF.jobs)) {
          if ((!job.time && job.time !== 0) || (!job.value && job.value !== 0)) {
            this.$notify({
              offset: 60,
              title: 'Отчет по численности обязательный',
              message: 'Заполните отчет по численности для всех работ',
              type: 'error',
            });

            return
          }
        }


        if (!job_flat || this.form.jobs.length > job_flat) {
          this.$notify({
            offset: 60,
            title: 'Отчет по численности обязательный',
            message: 'Заполните отчет по численности для всех работ',
            type: 'error',
          });
          return
        }


        const works = this.childForm.PROF.work_type.filter((f) => f !== null)

        if (works.length < this.childForm.PROF.jobs.length) {
          this.$notify({
            offset: 60,
            title: 'Отчет по численности обязательный',
            message: 'Заполните отчет по численности для всех работ',
            type: 'error',
          });

          return
        }
      }

      if (this.$route.params.type === 'PROF' && this.$store.state.project.work_type_require) {
        const workEmpty = [...this.form.work_type].filter((d) => {
          return !d || !d.value
        })

        for (let job of _.flatten(this.form.jobs)) {
          if ((!job.time && job.time !== 0) || (!job.value && job.value !== 0)) {
            this.$notify({
              offset: 60,
              title: 'Отчет по численности обязательный',
              message: 'Заполните отчет по численности для всех работ',
              type: 'error',
            });

            return
          }
        }

        if (this.form.work_type.length < this.form.jobs.length || workEmpty.length) {
          this.$notify({
            offset: 60,
            title: 'Заполните все поля',
            message: 'Поле "Вид работы" обязательное',
            type: 'error',
          });
          return
        }
      }

      this.loading = true
      let index_mul = 1

      let index = await fetchIndex(this.$store.state.project.id)

      const docRef = myFirestore
        .collection('projects')
        .doc(this.$store.state.project.id)
        .collection('reports').doc();

      if (this.form[`reportPROF`] === true) {
        this.form[`PROF`].index = index + index_mul
        const data = await this.save(true, {
          indexCalc: index + index_mul,
          type: 'PROF',
          form: this.childForm['PROF'],
          fromId: this.$route.params.id || docRef.id
        })
        this.form.reportPROF = data.id
        index_mul += 1
      }

      if (this.form[`reportTECH`] === true) {
        this.form[`TECH`].index = index + index_mul
        const data = await this.save(true, {
          type: 'TECH',
          indexCalc: index + index_mul,
          form: this.childForm['TECH'],
          fromId: this.$route.params.id || docRef.id
        })
        this.form.reportTECH = data.id
        this.form[`reportTECH`] = data.id
      }


      setTimeout(async () => {
        await this.save(false, {ref: docRef, indexCalc: index});
        this.loading = false
      }, 0)
    },
    async fetchFrom() {
      this.parent = {}

      if (!this.from) {
        return null
      }
      const report = await myFirestore
        .collection('projects')
        .doc(this.$store.state.project.id)
        .collection('reports')
        .doc(this.from).get()

      const data = report.data();

      this.parent = data;

      this.form = {
        ...this.form,
        turn: data.turn,
        datetime: dayjs(this.form.datetime.split('T')[0]).format('YYYY-MM-DD'),
        dateunix: data.dateunix,
      }
    },
    getTotalMaterials(_jobs, work_type) {
      const jobs = _jobs.filter((job) => job.is_select);
      const count = jobs.reduce(function (a, b) {
        if (b.job.is_unit_value) {
          return a + Number(String(b['total']).replace(',', '.'));
        } else {
          return a + Number(b['value']);
        }
      }, 0);
      return `${+count.toFixed(4)} ${work_type ? work_type.value : ''}`;

    },
    async addObject(n) {
      if ((this.$route.params.type === 'JOB' || this.$route.params.type === 'MAIN')) {
        this.form.jobs = [];
        this.form.jobs_internal = [];
      }

      if (this.$route.params.type === 'MATERIALS') {
        this.form.jobs = [[]];
        this.form.jobs_internal = [];
        await this.getOptionalWork();
      }

      this.form.object = n;
    },
    checkJoint(joints) {
      const joint = joints[joints.length - 1];
      myFirestore
        .collection('projects')
        .doc(this.$store.state.project.id)
        .collection('reports')
        .where('joints_ids', 'array-contains-any', [`${joint.line}.${joint.id}`])
        .get().then((d) => {
        if (d.size) {
          this.$confirm(`Вы действительно хотите записать стык с номером ${joint.id} ?`,
            `Стык с номером ${joint.id} уже сварен`, {
              confirmButtonText: 'Да',
              cancelButtonText: 'Нет',
              type: 'warning',
            }).catch(() => {
            joints.pop();
          });
        }
      });
    },
    close() {
      this.createOpen = false

    },
    openDialog(line) {
      this.$confirm('После смены линии вся введенная информация по стыкам будет удалена, продолжить?', 'Подтверждение', {
        confirmButtonText: 'Да',
        cancelButtonText: 'Нет',
        type: 'warning',
      }).then(() => {
        this.updated = false;
        this.form.joints = [{
          id_joint: null,
          welder: null,
          materials: null,
          leader: null,
          axe_elevation: null,
        }];
        this.pickLine(line);
        this.updated = true;

      });
    },
    async init() {
      if (this.initBlock) {
        return false
      }

      this.initBlock = true

      await this.getOptionalWork();
      const empty = this.emptyData();
      this.form = {
        ...empty.form
      }
      this.role = await getRole(this.$store.state.project.id);

      this.jobs = empty.jobs;

      this.jobs_internal = empty.jobs_internal;
      this.work_type = empty.work_type;
      this.work_type_dir = empty.work_type_dir;

      this.from = this.$route.query.from;

      await this.fetchUser();
      if (this.$route.params.id) {
        await this.fetchData();
        // if (this.$route.name === 'reportsCopy') {
        //   this.form.datetime = dayjs().format();
        //   this.from = null;
        //
        //   this.parent = {}
        //
        //   this.form = {
        //     ...(await copyChild(this.form, this.$store.state.project.id)),
        //     from: null
        //   }
        //   await this.fetchChilds();
        // } else {
        // }


        this.fetchFrom()

      } else {
        let month = getCurrentMonth(this.$store.state.project.plan.name);
        if (String(month).length === 1) {
          month = '0' + month
        }

        const year = this.$store.state.project.plan.name.split('-')[1]
        const unixDateStart = dayjs(year + '-' + month + '-' + '01' + ' ' + '00:00:00').unix()

        const unixDateEnd = dayjs(year + month + dayjs(unixDateStart * 1000).daysInMonth() + ' 00:00:00').unix()

        if (!dayjs().isBetween(dayjs(unixDateStart * 1000).format(), dayjs(unixDateEnd * 1000).format(), null, '[]')) {
          if (unixDateEnd > dayjs().unix()) {
            this.form.dateunix = dayjs(dayjs(unixDateStart * 1000).format('YYYY-MM-DD') + 'T00:00:00+00:00').utc().unix()
            this.form.datetime = dayjs(unixDateStart * 1000).format()
          }

          if (unixDateStart < dayjs().unix()) {
            this.form.dateunix = dayjs(dayjs(unixDateEnd * 1000).format('YYYY-MM-DD') + 'T00:00:00+00:00').utc().unix()
            this.form.datetime = dayjs(unixDateEnd * 1000).format()
          }
        }

        await this.fetchIndex();
      }

      this.form_saved = JSON.parse(JSON.stringify(this.form));

      setTimeout(() => {
        this.initData = true;
      }, 300)

      if (this.$route.params.type === 'WILD_PIPE') {
        this.joint_options.lines = await this.getWorkType('line');
        this.joint_options.welders = await this.getWorkType('welder');
        this.joint_options.materials = await this.getWorkType('welder_cons');
        this.joint_options.team = await this.getWorkType('team');
        if (this.form.line) {
          this.pickLine(this.form.line);
        }
      } else {
        this.joint_options.executor = await this.getWorkType('executor');
      }

      setTimeout(() => {
        this.initBlock = false
      }, 500)
      await this.fetchIndex();

      this.loader = false;

    },
    async fetchChilds() {
      if (this.form[`reportPROF`]) {
        this.fetchChild('PROF')
      }

      if (this.form[`reportTECH`]) {
        this.fetchChild('TECH')
      }
    },
    async fetchChild(type) {
      const data = await fetchReport(this.$store.state.project.id, this.form[`report${type}`])
      const report = data.data()


      this.childForm[type] = {
        jobs: Object.values(report.jobs),
        jobs_internal: report.jobs_internal,
        work_type: report.work_type,
        work_type_dir: report.work_type_dir,
        turn: report.turn,
        daily_plan: report.daily_plan,
      }

      this.childFormSave[type] = {...this.childForm[type]}
    },
    sendReport() {
      this.$prompt('Пожалуйста введите email', 'Отправка отчета', {
        confirmButtonText: 'Отправить',
        inputValue: authFirestore.currentUser.email,
        cancelButtonText: 'Закрыть',
        inputPattern: /[\w!#$%&'*+/=?^_`{|}~-]+(?:\.[\w!#$%&'*+/=?^_`{|}~-]+)*@(?:[\w](?:[\w-]*[\w])?\.)+[\w](?:[\w-]*[\w])?/,
        inputErrorMessage: 'Некорректный емайл',
      }).then(({value}) => {
        const proxy = firebase.functions().httpsCallable('onMailReports');
        proxy(
          {
            projectId: this.$store.state.project.id,
            reportId: this.$route.params.id,
            email: value,
          },
        ).then(() => {
          this.$notify({
            offset: 60,

            title: 'Успешно!',
            message: 'Отчет отправлен вам на почту',
            type: 'success',
          });
        }).catch(() => {
          this.$notify({
            offset: 60,

            title: 'Ошибка',
            message: 'Произошла ошибка, попробуйте позже',
            type: 'error',
          });
        }).finally(() => {
          this.loading = false;
        });
      });
    },
    async getOptionalWork() {
      let req = null;
      const result = [];

      if (this.$route.params.type !== 'MATERIALS') {
        req = myFirestore
          .collection('projects')
          .doc(this.$store.state.project.id)
          .collection('works_type')
          .where('type', 'in', ['job', 'JOB']);


      } else {
        req = myFirestore
          .collection('projects')
          .doc(this.$store.state.project.id)
          .collection('jobs')
          .where('type', '==', 'JOB')
          .where(`objects`, 'array-contains-any', [this.form.object && this.form.object.id || 'all']);
      }

      await req.get()
        .then((data) => {
          data.forEach((subDoc) => {
            const data = subDoc.data();
            result.push({
              label: data.name,
              value: data.unit,
              id: data.id || subDoc.id,
              dir: data.dir || null,
            });
          });
        })
        .finally(() => {
          this.options_works = [
            {
              label: 'Не выбрано',
              value: null,
            },
            ...result,
          ];
        });
    },
    async removeReport(flag) {
      if (this.from) {
        await myFirestore
          .collection('projects')
          .doc(this.$store.state.project.id)
          .collection('reports')
          .doc(this.from)
          .update({
            [`report${this.$route.params.type}`]: null,
            [this.$route.params.type]: {
              workers: '',
              itr: '',
              workers_plan: '',
              itr_plan: ''
            }
          });
      }

      if (this.form[`reportTECH`]) {
        myFirestore
          .collection('projects')
          .doc(this.$store.state.project.id)
          .collection('reports')
          .doc(this.form[`reportTECH`]).delete()
      }

      if (this.form[`reportPROF`]) {
        myFirestore
          .collection('projects')
          .doc(this.$store.state.project.id)
          .collection('reports')
          .doc(this.form[`reportPROF`]).delete()
      }

      // if (this.$route.name === 'reportsCopy') {
      //   this.$router.push(`/dashboard/reports/${this.$route.params.type}`);
      //
      //   return
      // }


      myFirestore
        .collection('projects')
        .doc(this.$store.state.project.id)
        .collection('reports')
        .doc(this.$route.params.id).delete()
        .then((data) => {
          if (!flag) {
            this.$notify({
              offset: 60,

              title: 'Успешно!',
              message: 'Отчет удален',
              type: 'success',
            });
          }
          setTimeout(() => {
            this.back();
          }, 1000);
        });
    },
    deleteReport() {
      this.$confirm('Вы действительно хотите удалить этот отчет?', 'Подтверждение', {
        confirmButtonText: 'Да',
        cancelButtonText: 'Нет',
        type: 'warning',
      }).then(async () => {
        this.removeReport();
      });
    },
    fetchUser() {
      myFirestore
        .collection('projects')
        .doc(this.$store.state.project.id)
        .collection('users')
        .where('uid', '==', this.$store.state.company.uid || authFirestore.currentUser.uid)
        .get()
        .then((data) => {
          data.forEach((subDoc) => {
            const user = subDoc.data();
            if (user.name && user.position && user.position.length) {
              this.isCreatedUser = subDoc.id;
            }
            this.user = {
              ...user,
              name: user.name || authFirestore.currentUser.email,
              user_profile_id: subDoc.id,
            };
          });

        })
    },
    deleteJoint(index) {
      const joints = this.form.joints;
      joints.splice(index, 1);
      this.form.joints = joints;
    },
    update({data, new_joint, joint}) {
      const joint_add = {
        ...new_joint,
        dia: toFloat(new_joint.dia),
        thi: toFloat(new_joint.thi),
        inc: toFloat(new_joint.inc),
        label: String(new_joint.id),
        value: String(new_joint.id),
        steel_grade: String(new_joint.steel_grade),
      };
      this.form.line.data = data;
      this.pickLine(this.form.line, joint_add);

      if (this.form.joints[joint].id_joint) {
        this.form.joints[joint].id_joint.push(joint_add);
      } else {
        this.form.joints[joint].id_joint = [joint_add];
      }
    },
    pickLine(line, new_line = null) {
      const c = {...this.form.line};
      try {
        if (!line.value) return;
        const current_line = this.joint_options.lines.find((f) => f.value === line.value);
        this.current_line = current_line;

        this.form.line = line;
        if (c.label && line.value !== c.value) {
          this.openDialog(line);
        } else {
          const joints = current_line && current_line.data ? current_line.data.joints.map((joint) => ({
            ...joint,
            dia: toFloat(joint.dia),
            thi: toFloat(joint.thi),
            inc: toFloat(joint.inc),
            line: line.value,
            label: String(joint.id),
            value: String(joint.id),
            steel_grade: String(joint.steel_grade),
            i: Number(joint.id),
          })) : [];
          if (new_line) {
            joints.push(new_line);
          }
          this.joint_options.joints = _.orderBy(joints, 'i', 'asc');

          this.joint_options.joints = this.joint_options.joints.map((joint) => ({
            dia: toFloat(joint.dia),
            thi: toFloat(joint.thi),
            inc: toFloat(joint.inc),
            line: line.value,
            label: String(joint.id),
            value: String(joint.id),
            steel_grade: String(joint.steel_grade),
            id: joint.id,
          }));

        }
      } catch (e) {
        console.error(e);
      }
    },
    getWorkType(type) {
      return new Promise((resolve, reject) => {
        const result = [];
        myFirestore
          .collection('projects')
          .doc(this.$store.state.project.id)
          .collection('works_type')
          .where('type', '==', type).get().then((data) => {
          data.forEach((subDoc) => {
            const data = subDoc.data();
            result.push({
              data: data,
              value: subDoc.id,
              label: (data.name || data.id || '') + (data.stamp ? ' ' + data.stamp : ''),
            });
          });
          resolve(result);
        });
      });
    },
    preview(file) {
      window.open(file, '_blank');
    },
    addJoint() {
      this.form.joints.push({
        line: null,
        id_joint: null,
        welder: null,
        materials: null,
        leader: null,
        axe_elevation: null,
      });
    },
    addFile(f) {
      this.form.files.push(f);
    },
    deleteImg(id) {
      this.$confirm('Вы действительно хотите удалить этот файл?', 'Подтверждение', {
        confirmButtonText: 'Да',
        cancelButtonText: 'Нет',
        type: 'warning',
      }).then(() => {
        const images = [...this.form.files];
        images.splice(id, 1);
        this.form.files = images;
      });
    },
    fetchData() {
      return myFirestore
        .collection('projects')
        .doc(this.$store.state.project.id)
        .collection('reports')
        .doc(this.$route.params.id)
        .get().then((data) => {
          const subData = data.data();
          this.fileList = this.form.files.map((f, i) => {
            return {
              url: f,
              name: 'file__' + i,
            };
          });

          if (this.$route.params.type === 'MATERIALS') {
            const {jobs_internal, jobs} = {...subData};
            subData.jobs = jobs_internal;
            subData.jobs_internal = jobs;
          }

          if (subData.from) {
            this.from = subData.from;
          }


          if (this.$route.params.type === 'TECH' || this.$route.params.type === 'PROF' || this.$route.params.type === 'MATERIALS') {
            this.form = {
              ...this.form,
              ...subData,
              jobs: [...Object.values(subData.jobs)],
            };
            this.from = this.form.from
          } else {
            this.form = {
              ...this.form,
              ...subData,
            };
          }
          this.form.datetime = dayjs(this.form.datetime.split('T')[0]).format('YYYY-MM-DD')
          this.fetchChilds();
        });
    },
    async fetchIndex() {
      if (!this.$route.params.id && this.$route.name !== 'reportsCopy') {
        this.form.index = await fetchIndex(this.$store.state.project.id)
      }
    },
    addJob(dd, index, editIndex) {
      if (editIndex !== undefined && editIndex !== null) {
        this.form.jobs[editIndex] = dd
        this.form.jobs = [...this.form.jobs]
        return
      }

      if (this.$route.params.type !== 'TECH' && this.$route.params.type !== 'PROF' && this.$route.params.type !== 'MATERIALS') {
        this.form.jobs.push(dd);
      } else {
        this.form.jobs[index].push(dd);
      }
    },
    openEdit(job, index) {
      this.$refs.addJob.openWithForm(job, index)
    },
    async copyJob(index) {
      const jobs = [...this.form.jobs];
      const uid = uuidv4();
      this.form.jobs = [...jobs, {
        ...JSON.parse(JSON.stringify(jobs[index])),
        uid: uid
      }];

      const copyJob = this.childForm.PROF.jobs.findIndex(((j) => {
        return j[0] && j[0].linkedUid === jobs[index].uid
      }))

      const copyJobTech = this.childForm.TECH.jobs.findIndex(((j) => {
        return j[0] && j[0].linkedUid === jobs[index].uid
      }))

      if (copyJobTech !== -1) {
        const copyJobsDataTech = this.childForm.TECH.jobs[copyJobTech].map((j) => ({
          ...j,
          linkedUid: uid,
          uid: uuidv4(),
        }))

        this.childForm.TECH.jobs.push(copyJobsDataTech)
        this.childForm[`TECH`].work_type.push(this.childForm[`TECH`].work_type[copyJob])
        this.childForm[`TECH`].work_type_dir.push(this.childForm[`TECH`].work_type_dir[copyJob])
      }


      if (copyJob !== -1) {
        const copyJobsData = this.childForm.PROF.jobs[copyJob].map((j) => ({
          ...j,
          linkedUid: uid,
          uid: uuidv4(),
        }))
        this.childForm.PROF.jobs.push(JSON.parse(JSON.stringify(copyJobsData)))

        this.childForm[`PROF`].work_type.push(this.childForm[`PROF`].work_type[copyJob])
        this.childForm[`PROF`].work_type_dir.push(this.childForm[`PROF`].work_type_dir[copyJob])
      }

      this.form[`PROF`] = {
        ...await this.updateParent(null, this.childForm['PROF']),
        index: this.form[`PROF`].index || null
      }

      this.form[`TECH`] = {
        ...await this.updateParent(null, this.childForm['TECH']),
        index: this.form[`TECH`].index || null
      }


      setTimeout(() => {
        this.updateChildFlag = false
        this.form = {...this.form}
        this.$forceUpdate()
      }, 100)
    },
    deleteJob(index, mainIndex = null) {

      const jobs = [...this.form.jobs]

      try {
        this.createReport('PROF', jobs[index], true)
      } catch (e) {
      }
      setTimeout(() => {
        try {
          this.$refs.listJob.deleteJobs()
        } catch (e) {
        }

        if (mainIndex !== null) {
          jobs[mainIndex].splice(index, 1);
        } else {
          jobs.splice(index, 1);
        }


        this.childForm = {...this.childForm}
        this.childFormSave = {...this.childFormSave}

        this.form.jobs = [...jobs];
      }, 500)
    },
    async save(flag, {type, form, fromId, indexCalc, ref}) {


      const userOwnerResponse = await myFirestore
        .collection('projects')
        .doc(this.$store.state.project.id)
        .collection('users')
        .where('uid', '==', this.$store.state.project.owner)
        .get()

      let userOwner = {}

      userOwnerResponse.forEach((e) => {
        userOwner = e.data()
      })

      let _form = form ? {...this.form, ...form, type} : {...this.form};
      return new Promise(async (resolve, reject) => {
        if (this.loader) return false;

        if (this.$route.params.type === 'WILD_PIPE' || type === 'WILD_PIPE') {
          for (let joint of _form.joints) {
            if (!joint.id_joint || !joint.id_joint.length) {
              this.$notify({
                offset: 60,
                title: 'Ошибка!',
                message: 'Необходимо указать стыки во всех блоках',
                type: 'error',
              });
              return false;
            }
          }
        }

        this.loader = true;

        if (!_form.datetime) {
          this.$notify({
            offset: 60,

            title: 'Заполните все поля!',
            message: 'Пожалуйста заполните поле c датой',
            type: 'error',
          });
          return;
        }

        let jobs = _form.jobs;
        let jobs_ids = [];
        let work_type_ids = [];

        _form.work_type = Array.from(_form.work_type, item => typeof item === 'undefined' || !item || !item.value ? null : item);

        if (type === 'TECH' || this.$route.params.type === 'TECH' || type === 'PROF' || this.$route.params.type === 'PROF' || this.$route.params.type === 'MATERIALS') {
          jobs.forEach((job) => job.forEach((j) => jobs_ids.push(j.job.id)));
          _form.jobs.forEach((job, index) => {
            job.forEach((j, i) => {
              try {
                _form.jobs[index][i].is_select = _form.jobs[index][i].is_select || null;
                _form.jobs[index][i].job.work_type_name = (_form.work_type[index] && _form.work_type[index].label) || null;
                _form.jobs[index][i].job.work_type = (_form.work_type[index] && _form.work_type[index].id) || null;

                if (_form.work_type[index].id) {
                  work_type_ids.push(_form.work_type[index].id);
                }
              } catch (e) {
                _form.jobs[index][i].is_select = _form.jobs[index][i].is_select || null;
                _form.jobs[index][i].job.work_type_name = null;
              }
            });
          });
          jobs = {..._form.jobs};
        } else {
          jobs_ids = jobs.map((job) => job.job.id);
          work_type_ids = jobs.map((job) => job.job.work_type || null);
        }

        const joints_ids = [];
        if (_form.joints && _form.joints[0] && _form.joints[0].id_joint) {
          _form.joints.forEach((joint) => {
            if (joint.id_joint) {
              joint.id_joint.forEach((j) => {
                if (j.line) {
                  joints_ids.push(`${j.line}.${j.id}`);
                }
              });
            }
          });
        }

        let line = {};
        try {

          if (_form.line) {
            const {
              name,
              stamp,
              type,
              id,
            } = _form.line.data;

            line = {
              ..._form.line,
              data: {
                id,
                name,
                stamp,
                type,
              },
            };
          }
        } catch (e) {
          console.log(e);
        }

        let wild_data = {};
        const user = authFirestore.currentUser;

        if (!this.$route.params.id || (type && form)) {
          _form.jobs_internal = _form.jobs_internal.map((job) => {
            return {
              ...job,
              is_select: false
            }
          })

          user.providerData.forEach(() => {
            if (indexCalc) {
              _form.index = indexCalc
            }

            if (fromId) {
              _form.reportPROF = null
              _form.reportTECH = null
            }

            let create = null

            let userId = this.$store.state.company.uid || this.user.uid;
            let user = this.user;

            if (this.form.user && this.form.user.value) {
              userId = this.form.user.value
              if (this.form.user._data) {
                user = {
                  ...this.form.user._data,
                  user_profile_id: userId,
                  value: this.form.user.value,
                  label: this.form.user.label,
                }
              } else {
                user = this.form.user;
              }
            }


            if (_form.reportPROF && this.$route.params.id) {
              this.updateSub(_form.reportPROF, 'PROF', {user, reporter: this.user, userId})
            }

            if (_form.reportTECH && this.$route.params.id) {
              this.updateSub(_form.reportTECH, 'TECH', {user, reporter: this.user, userId})
            }


            console.log(
              {
                ..._form,
                jobs,
                joints_ids,
                form: fromId || null,
                jobs_ids,
                line,
                planId: (this.$store.state.project.plan && this.$store.state.project.plan.id) || null,
                work_type_ids,
                object: this.form.object,
                extended_data: wild_data || null,
                datetime: dayjs(this.form.datetime).format(),
                userId,
                idProject: this.$store.state.project.id,
                nameProject: this.$store.state.project.name,
                ownerProject: this.$store.state.project.owner,
                emailOwnerProject: (userOwner && userOwner.email) || '',
                company: (userOwner && userOwner.company) || '',
                reporterId: this.$store.state.company.uid || user.uid || this.user.uid,
                type: type || this.$route.params.type,
                dateunix: dayjs(dayjs(this.form.datetime).format('YYYY-MM-DD') + 'T00:00:00+00:00').unix(),
                user: user,
                reporter: this.user,
              }, 'HELLO WORLD'
            )

            if (ref) {
              let batch = myFirestore.batch();
              batch.set(ref, JSON.parse(JSON.stringify({
                ..._form,
                jobs,
                joints_ids,
                form: fromId || null,
                jobs_ids,
                line,
                planId: (this.$store.state.project.plan && this.$store.state.project.plan.id) || null,
                work_type_ids,
                object: this.form.object,
                extended_data: wild_data || null,
                datetime: dayjs(this.form.datetime).format(),
                userId,
                idProject: this.$store.state.project.id,
                nameProject: this.$store.state.project.name,
                ownerProject: this.$store.state.project.owner,
                emailOwnerProject: (userOwner && userOwner.email) || '',
                company: (userOwner && userOwner.company) || '',
                reporterId: this.$store.state.company.uid || user.uid || this.user.uid,
                type: type || this.$route.params.type,
                dateunix: dayjs(dayjs(this.form.datetime).format('YYYY-MM-DD') + 'T00:00:00+00:00').unix(),
                user: user,
                reporter: this.user,
              })));
              create = batch.commit()
            } else {
              create = myFirestore
                .collection('projects')
                .doc(this.$store.state.project.id)
                .collection('reports')
                .add(JSON.parse(JSON.stringify({
                  ..._form,
                  jobs,
                  joints_ids,
                  from: fromId,
                  jobs_ids,
                  line,
                  idProject: this.$store.state.project.id,
                  nameProject: this.$store.state.project.name,
                  ownerProject: this.$store.state.project.owner,
                  emailOwnerProject: (userOwner && userOwner.email) || '',
                  company: (userOwner && userOwner.company) || '',
                  planId: (this.$store.state.project.plan && this.$store.state.project.plan.id) || null,
                  work_type_ids,
                  object: this.form.object,
                  extended_data: wild_data || null,
                  datetime: dayjs(this.form.datetime).format(),
                  userId,
                  reporterId: this.$store.state.company.uid || user.uid || this.user.uid,
                  type: type || this.$route.params.type,
                  dateunix: dayjs(dayjs(this.form.datetime).format('YYYY-MM-DD') + 'T00:00:00+00:00').unix(),
                  user: user,
                  reporter: this.user,
                })))
            }

            create.then(async (docRef) => {
              console.log(docRef.id, 'docRef.id')
              if (flag) {
                setTimeout(() => {
                  return resolve({..._form, id: docRef.id})
                }, 500)
              } else {

                try {
                  if (this.from) {
                    this.updateParent(docRef.id)
                  }
                } catch (e) {
                  console.error(e);
                  return
                }
                this.$notify({
                  offset: 60,

                  title: 'Успешно!',
                  message: 'Отчет добавлен',
                  type: 'success',
                });
                this.form = {
                  comment: '',
                  object: '',
                  jobs: [],
                  index: '-',
                };

                setTimeout(() => {
                  this.$router.push('/dashboard/reports/' + this.$route.params.type);
                }, 1000);
              }
            }).finally(() => {
              this.loader = false;
            })
              .catch((error) => {
                console.error(error)
                this.$notify({
                  offset: 60,

                  title: 'Упс... ',
                  message: 'Произошла ошибка повторите позже',
                  type: 'error',
                });
              });
          });
        } else {
          if (
            this.role === 'admin' &&
            (this.form_saved.user && this.form_saved.user.value) !== (this.form.user && this.form.user.value)
          ) {
            let userId = this.$store.state.company.uid || this.user.uid;
            let user = this.user;

            if (this.form.user && this.form.user.value) {
              userId = this.form.user.value
              if (_form.user._data) {
                user = {
                  ..._form.user._data,
                  user_profile_id: userId,
                  value: _form.user.value,
                  label: _form.user.label,
                }
              } else {
                user = _form.user
              }
            }

            _form.user = user;
            _form.userId = userId;
            _form.reporter = this.user;
          }


          if (_form.reportPROF && this.$route.params.id) {
            this.updateSub(this.form.reportPROF, 'PROF', {
              user: _form.user,
              reporter: _form.reporter,
              userId: _form.userId
            })
          }

          if (_form.reportTECH && this.$route.params.id) {
            this.updateSub(this.form.reportTECH, 'TECH', {
              user: _form.user,
              reporter: _form.reporter,
              userId: _form.userId
            })
          }

          if (this.from) {
            this.updateParent(this.$route.params.id)
          }

          myFirestore
            .collection('projects')
            .doc(this.$store.state.project.id)
            .collection('reports')
            .doc(this.$route.params.id)
            .update(JSON.parse(JSON.stringify({
              ..._form,
              jobs,
              joints_ids,
              extended_data: wild_data || null,
              datetime: dayjs(this.form.datetime).format(),
              dateunix: dayjs(dayjs(this.form.datetime).format('YYYY-MM-DD') + 'T00:00:00+00:00').unix(),
            }))).then(() => {
            if (flag) {
              return resolve(this.$route.params.id)
            } else {
              this.$notify({
                offset: 60,
                title: 'Успешно!',
                message: `Отчет сохранен`,
                type: 'success',
              });

              this.$router.push(`/dashboard/reports/${this.$route.params.type}`);
            }
          }).finally(() => {
            this.loader = false;
          }).catch((error) => {
            this.$notify({
              offset: 60,

              title: 'Упс... ',
              message: 'Произошла ошибка повторите позже',
              type: 'error',
            });
          });
        }
      });
    },
    async updateSub(id, type, _form = {}) {
      try {
        await myFirestore
          .collection('projects')
          .doc(this.$store.state.project.id)
          .collection('reports')
          .doc(id)
          .update(JSON.parse(JSON.stringify({
            ...this.childForm[type],
            jobs: {...(this.childForm[type].jobs || {})},
            object: this.form.object,
            turn: this.form.turn,
            ..._form,
            datetime: dayjs(this.form.datetime).format(),
            dateunix: dayjs(dayjs(this.form.datetime).format('YYYY-MM-DD') + 'T00:00:00+00:00').unix(),
          })));
      } catch (e) {
        console.log(e)
      }
    },
    async updateParent(id, form = null) {

      let _form = form || this.form

      if (_form && _form.jobs) {
        _form.jobs = _form.jobs.map((job) => {
          return uniqBy(job, 'uid')
        })
      }
      const result = {
        workers: 0,
        itr: 0,
        workers_plan: 0,
        itr_plan: 0,
        index: form === null ? _form.index : null
      }
      _form.jobs.forEach((jb) => {
        jb.forEach((j) => {
          if (j.job.kind && j.job.kind.value === 'itr') {
            result.itr = result.itr + Number(j.value)
            result.itr_plan = result.itr_plan + Number(j.plan)
          } else {
            result.workers = result.workers + Number(j.value)
            result.workers_plan = result.workers_plan + Number(j.plan)
          }
        });
      })

      if (form) {
        return result
      }

      await myFirestore
        .collection('projects')
        .doc(this.$store.state.project.id)
        .collection('reports')
        .doc(this.from)
        .update(JSON.parse(JSON.stringify({
          [`report${this.$route.params.type}`]: id,
          [this.$route.params.type]: result
        })));
    }
  },

};
</script>
<style lang="scss">
.creat-reports-vue-container {
  .el-textarea textarea {
    height: 36px;
  }

  .navigate-btn {
    margin-top: 20px;
    display: block;
  }

  .reports-create, .alert-report {
    margin: 0 auto;
    max-width: 382px;
    padding-top: 20px;
    width: calc(100% - 40px);
    overflow: hidden;
    padding-bottom: 100px;

    .add-jobs {
      display: flex;
      flex-direction: column;
    }

    .date-create {
      display: flex;
      justify-content: space-between;
      align-items: center;
    }

    h4 {
      display: flex;
      flex-direction: column;
      align-items: flex-end;
      margin: 0;

      small {
        font-size: 10px;
        font-weight: 400;
      }
    }
  }

  .add-btn {
    width: 100%;

    > > > .add {
      width: 100%;
    }

    margin-top: 20px;

    &.add-jobs {
      margin-top: 0;
    }
  }

  .select-job {
    margin-top: 20px;

    > > > .el-select {
      width: 100%;
    }
  }

  .report-li {
    span {
    }
  }

  .report-value {
    strong {
      font-weight: bold;
    }
  }

  @media screen and (max-width: 500px) {
    .report-value {
      width: 100%;
      justify-content: space-between !important;
    }

    .report-li {
      display: flex;
      flex-direction: column;
      align-items: flex-start !important;


      .el-icon-close {
        margin-bottom: 12px;
      }

      span {
        max-width: 100%;
        font-weight: bold;
      }
    }
  }

  .report-li-title {
    font-size: 14px;
    margin-top: 18px;
    width: 100%;
    display: flex;
    justify-content: flex-start;
    margin-bottom: 0px;
  }

  .report-add-job {
    width: 100%;
    margin-top: 20px;
    display: flex;
    align-items: flex-end;
    flex-direction: column;
    padding: 20px 0;
    border-top: 1px solid #ccc;
    border-bottom: 1px solid #ccc;

    .report-ul {
      display: flex;
      width: 100%;
      flex-direction: column;
      margin-bottom: 22px;
    }

    .jobs-li {
      border-bottom: 1px solid rgba(0, 0, 0, 0.18);

      &:last-child {
        border-bottom: none;
      }

      padding-bottom: 12px;
    }

    .report-li {
      display: flex;
      margin-top: 3px;
      justify-content: space-between;
      min-height: 58px;
      padding: 12px 0px;
      text-align: left;
      align-items: center;
      border-bottom: 1px solid rgba(0, 0, 0, 0.18);
      cursor: pointer;


      &.with-check {
        border-bottom: none;
        padding-bottom: 0px;
      }

      &:last-child {
        border-bottom: none;
      }
    }
  }

  .report-file {
    display: flex;
    align-items: flex-end;
    flex-direction: column;
    margin-top: 18px;
  }


  .create-footer {
    display: flex;
    justify-content: space-between;
    position: fixed;
    height: 64px;
    border-top: 1px solid #ddd;
    align-items: center;
    max-width: 382px;
    width: calc(100% - 40px);
    bottom: 0;
    background: #fff;
    z-index: 3;
  }

  .report-ul {
    width: 100%;
  }

  .dop-container {
    display: flex;
    justify-content: space-between;
    width: 100%;
    align-items: center;
  }

  > > > .el-form-item, > > > .el-form-item__content {
    display: flex;
    flex-direction: column;
    justify-content: flex-start;

    .el-form-item__label {
      padding: 0 !important;
      margin-top: 10px;
    }
  }

  .report-value {
    display: flex;
    justify-content: flex-end;
    align-items: center;

    strong {
      opacity: 0.8;
      font-weight: bold;
    }

    > > > .el-input__inner {
      text-align: right;
      margin-right: 8px;
    }


  }

  .preview-images {
    display: flex;
    flex-wrap: wrap;
    width: 100%;
    flex: 1;
    margin-top: 16px;
    margin-bottom: 16px;

    .preview-img {
      width: 92px;
      height: 92px;
      margin: 6px;
    }

    .controls {
      display: flex;
      justify-content: space-between;
      background-color: rgba(0, 0, 0, 0.3);
      width: 92px;
      height: 92px;
      border-radius: 6px;
      margin-top: -98px;
      z-index: 2;
      position: relative;
      align-items: center;

      i {
        font-size: 24px;
        color: #fff;
        margin: 0 12px;
        cursor: pointer;
      }
    }

    img {
      width: 92px;
      height: 92px;
      border-radius: 6px;
      cursor: pointer;
      z-index: 1;
      position: relative;
    }
  }

  .add-block {
    display: flex;
    justify-content: flex-end;
  }

  .line-data {
    padding: 5px 15px;
    margin-bottom: 10px;
    background: #fff;
    background: #f7f7f7;
    box-shadow: 0px 0px 8px 0px #ccc;
    border-radius: 5px;
  }

  .pipe-close {
    display: flex;
    justify-content: flex-end;
    align-items: flex-end;
    flex-direction: column;
    margin-bottom: -42px;
    margin-top: 10px;
    font-size: 20px;
    cursor: pointer;

    i {
      margin-bottom: 10px;
    }

    > > > .add-btn-joint {
      z-index: 2;
      position: relative;
    }
  }

  .reports-edit-header {
    display: flex;
    justify-content: space-between;
    margin-bottom: 20px;
    align-items: center;

    .i-container {
      width: 50%;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 24px;
      padding: 6px;
      cursor: pointer;
      border: 1px solid #eee;
      color: #000;
      text-decoration: none;
      flex-direction: column;

      i {
        height: 24px;
      }

      span {
        vertical-align: center;
        display: flex;
        align-items: center;
        font-size: 10px;
        height: 22px;
        margin-top: 6px;
      }

      &:hover {
        background: #eee;
      }
    }
  }

  .reports-create {
    padding: 0 20px;
  }

  .add-job {
    margin-top: -30px;
  }

  .reports-create {
    padding-top: 40px;
    padding-bottom: 70px;
  }

  .report-add-job {
    .line-data {
      padding-top: 24px;
      margin-bottom: 20px;
    }

    .report-ul.mul {
      margin-bottom: 0;
    }

    .add-block {
      margin-top: 30px;
    }

    .report-li > > > .el-form-item__label {
      height: 32px;
    }

    .col-vo {
      > > > .el-input__inner {
        width: 68px !important;
        padding: 0 5px !important;
      }
    }

    .time {
      > > > .el-input__inner {
        width: 58px !important;
        padding: 0 8px 0 2px !important;
        margin-right: 0px;
      }
    }
  }

  .reports-mul {
    > > > .el-form-item__label {
      margin-top: 2px;
    }

    > > > .el-form-item {
      margin-bottom: 10px;
    }
  }

  .total {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-top: 20px;
    margin-bottom: 14px;
  }

  .links-list {
    display: flex;
    justify-content: space-between;
    width: 100%;
    margin-bottom: 20px;
    margin-top: 20px;
    align-items: center;

    a {
      color: #3676cb;
      font-size: 14px;
      text-decoration: none;

      &:hover {
        text-decoration: underline;
      }
    }

    i {
      cursor: pointer;
      font-size: 20px;
      opacity: 0.8;
    }
  }

  .report-child-btn {
    display: flex;
    align-items: center;
  }

  .job-link {
    display: flex;
    text-align: left;
    font-weight: bold;
    text-decoration: underline;
    cursor: pointer;
  }

  .isModal {
    .reports-create {
      padding-top: 0 !important;
      border-bottom: none !important;
    }

    .report-add-job {
      border-top: none !important;
    }

    .create-footer {
      position: relative;
      border-top: none;
      width: 100% !important;
    }
  }
}

.tribute-container {
  background: #fff;
  z-index: 999;
  border: 1px solid #DCDFE6;
  border-radius: 4px;
  padding: 0;

  ul {
    list-style-type: none;
    padding-inline-start: 0px;
    margin-block-start: 0px;
    margin-block-end: 0px;

    li {
      padding: 8px 16px;
      box-sizing: border-box;
      cursor: pointer;

      &:hover {
        background: #409EFF;
        color: #fff;
      }
    }
  }
}

</style>

<style scoped lang="scss">
.disable-report {
  opacity: 0.6;
  pointer-events: none;
}

.el-icon-success {
  color: #2ecc71 !important;
  font-size: 28px !important;
  margin-left: 4px !important;
}
</style>
<style lang="scss">
.hidden-j {
  opacity: 0;
}
</style>



// WEBPACK FOOTER //
// src/views/Dashboard/Reports/Create.vue